<template>
  <van-popup
    v-model:show="visible"
    round
    style="width: 85%; background: transparent;"
    @click-overlay="close"
  >
    <div class="pwa-instructions">
      <div class="instructions-header">
        <span class="close-btn" @click="close">✕</span>
      </div>
      <p class="instructions-title">{{ t('download.pwaDownloadInstructions') }}</p>
      <img :key="instructionImage" :src="instructionImage" alt="" class="instructions-image" />
    </div>
  </van-popup>
</template>

<script setup lang="ts">
import { computed, ref, defineExpose } from 'vue';
import { useI18n } from 'vue-i18n';
import iosPwaEn from '@/assets/app-store/iosPwa_en.png';
import iosPwaPt from '@/assets/app-store/iosPwa.png';

const { t, locale } = useI18n();
const visible = ref(false);

const instructionImage = computed(() => {
  return locale.value === 'pt' ? iosPwaPt : iosPwaEn;
});

const open = () => {
  visible.value = true;
};

const close = () => {
  visible.value = false;
};

defineExpose({ open, close });
</script>

<style scoped>
.pwa-instructions {
  background: #f2f2f4;
  padding: 12px 12px 16px;
  border-radius: 12px;
  text-align: center;
}

.instructions-header {
  display: flex;
  justify-content: flex-end;
}

.close-btn {
  font-size: 18px;
  color: #000;
  cursor: pointer;
  line-height: 1;
  padding: 4px;
}

.instructions-title {
  margin: 0 0 12px;
  font-size: 14px;
  font-weight: 600;
  color: #000;
  line-height: 1.35;
}

.instructions-image {
  width: 100%;
  max-width: 280px;
  height: auto;
  display: block;
  margin: 0 auto;
}
</style>
